'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;

var _functional = require('../utils/functional');

function init(_ref) {
  var el = _ref.el;

  var trigger = (0, _functional.getElement)('.js-Scroll_Trigger');

  trigger.addEventListener('click', scrollTop);

  function scrollTop(e) {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
}